import React from 'react';
import { FileText } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import LegalPageLayout from '../components/LegalPageLayout';

const TermsOfService = ({ embedded = false }) => {
  const { lang } = useLanguage();
  const english = lang === 'en';

  return (
    <LegalPageLayout
      embedded={embedded}
      icon={FileText}
      title={english ? 'Terms of Service' : 'Algemene Voorwaarden'}
      updated={english ? 'Last updated: February 2026' : 'Laatst bijgewerkt: februari 2026'}
      backLabel={english ? 'Back to Home' : 'Terug naar Home'}
      testId="terms-back-btn"
    >
          {english ? <>
          <h2 style={{ fontSize: 20, fontWeight: 600, color: '#F4F7FB', marginTop: 0 }}>1. General</h2>
          <p>These Terms of Service apply to all services offered by Krypton9. By using our services, you agree to these terms.</p>

          <h2 style={{ fontSize: 20, fontWeight: 600, color: '#F4F7FB' }}>2. Services</h2>
          <p>Krypton9 provides AI consulting, implementation services, and an online platform for small and medium-sized businesses. We reserve the right to change or discontinue services with reasonable advance notice.</p>

          <h2 style={{ fontSize: 20, fontWeight: 600, color: '#F4F7FB' }}>3. User account</h2>
          <p>When you create an account, you are responsible for:</p>
          <ul>
            <li>Providing accurate and up-to-date information</li>
            <li>Keeping your login details confidential</li>
            <li>All activity that takes place under your account</li>
          </ul>

          <h2 style={{ fontSize: 20, fontWeight: 600, color: '#F4F7FB' }}>4. Intellectual property</h2>
          <p>All content, software, and materials on the Krypton9 platform belong to Krypton9 or its licensors and are protected by copyright and other intellectual property rights.</p>

          <h2 style={{ fontSize: 20, fontWeight: 600, color: '#F4F7FB' }}>5. Liability</h2>
          <p>Krypton9 is not liable for indirect or consequential damages or lost profits. Our liability is limited to the amount you paid for the service concerned during the 12 months preceding the claim.</p>

          <h2 style={{ fontSize: 20, fontWeight: 600, color: '#F4F7FB' }}>6. Governing law</h2>
          <p>These terms are governed by Dutch law. Disputes will be submitted to the competent court in the Netherlands.</p>

          <h2 style={{ fontSize: 20, fontWeight: 600, color: '#F4F7FB' }}>7. Contact</h2>
          <p>If you have questions about these terms, contact us at:</p>
          <p style={{ fontWeight: 500 }}>Email: info@krypton9.com</p>
          </> : <>
          <h2 style={{ fontSize: 20, fontWeight: 600, color: '#F4F7FB', marginTop: 0 }}>1. Algemeen</h2>
          <p>Deze Algemene Voorwaarden zijn van toepassing op alle diensten die worden aangeboden door Krypton9. Door gebruik te maken van onze diensten, gaat u akkoord met deze voorwaarden.</p>

          <h2 style={{ fontSize: 20, fontWeight: 600, color: '#F4F7FB' }}>2. Diensten</h2>
          <p>Krypton9 biedt AI-consultancy, implementatiediensten en een online platform voor MKB-bedrijven. Wij behouden ons het recht voor om diensten te wijzigen of te beëindigen met redelijke voorafgaande kennisgeving.</p>

          <h2 style={{ fontSize: 20, fontWeight: 600, color: '#F4F7FB' }}>3. Gebruikersaccount</h2>
          <p>Bij het aanmaken van een account bent u verantwoordelijk voor:</p>
          <ul>
            <li>Het verstrekken van accurate en actuele informatie</li>
            <li>Het vertrouwelijk houden van uw inloggegevens</li>
            <li>Alle activiteiten die plaatsvinden onder uw account</li>
          </ul>

          <h2 style={{ fontSize: 20, fontWeight: 600, color: '#F4F7FB' }}>4. Intellectueel eigendom</h2>
          <p>Alle content, software en materialen op het Krypton9-platform zijn eigendom van Krypton9 of haar licentiegevers en worden beschermd door auteursrecht en andere intellectuele-eigendomsrechten.</p>

          <h2 style={{ fontSize: 20, fontWeight: 600, color: '#F4F7FB' }}>5. Aansprakelijkheid</h2>
          <p>Krypton9 is niet aansprakelijk voor indirecte schade, gevolgschade of gederfde winst. Onze aansprakelijkheid is beperkt tot het bedrag dat u heeft betaald voor de betreffende dienst in de 12 maanden voorafgaand aan de claim.</p>

          <h2 style={{ fontSize: 20, fontWeight: 600, color: '#F4F7FB' }}>6. Toepasselijk recht</h2>
          <p>Op deze voorwaarden is Nederlands recht van toepassing. Geschillen worden voorgelegd aan de bevoegde rechter in Nederland.</p>

          <h2 style={{ fontSize: 20, fontWeight: 600, color: '#F4F7FB' }}>7. Contact</h2>
          <p>Voor vragen over deze voorwaarden kunt u contact opnemen via:</p>
          <p style={{ fontWeight: 500 }}>E-mail: info@krypton9.com</p>
          </>}
    </LegalPageLayout>
  );
};

export default TermsOfService;
